import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Socials from './Socials';
import CorpLinks from './CorpLinks';
import BrandLogo from './BrandLogo';
import GalleryLogo from './GalleryLogo';
import SearchForm from '../Search/SearchForm';
import { SITE_HOST, FOOTER_VERTICALS } from '../../consts';
import { segmentTrackEvent } from '../../utils';

export class Footer extends Component {
  render() {
    const { isMobile } = this.props;
    const renderedSocials = <Socials parent="Footer" />;
    const FooterSubscribe = <a className='footer-subscribe' href='/subscribe'>Subscribe</a>;
    const currentYear = new Date().getFullYear();

    const renderedVerticals = FOOTER_VERTICALS.map((vertical, i) => {
      return (
       <Link 
          key={i} 
          className='cat-link'
          to={`/${vertical}`} 
          onClick={() => {segmentTrackEvent('navigation', {action: 'category_footer_clicked', label: vertical })}}>
            {vertical}
        </Link> 
      )
    })

    return (
      <div className="footer" ref={node => this.footer = node}>

       <div className="footer-contents">
            <div className="footer-left">
              <div className="footer-content">
                <CorpLinks isMobile={isMobile} parent={"footer"}/>
              </div>

              <div className="footer-content">
                <div className="footer-subcontent">
                  {isMobile && 
                    <button id="ot-sdk-btn" className="ot-sdk-show-settings" >Cookie Settings</button>
                  }
                  <GalleryLogo />
                  <div className="footer-copyright">
                    <span>&copy;2010-{currentYear} Wow Media</span>
                    <span>Products, Inc doing business as PureWow. All rights reserved.</span>
                  </div>
                </div>
                {!isMobile && 
                  <div className="footer-subcontent">
                    {FooterSubscribe}
                    <button id="ot-sdk-btn" className="ot-sdk-show-settings" >Cookie Settings</button>
                  </div>
                }
              </div>
            </div>
            <div className="footer-right">
              <div className="footer-content">
                <BrandLogo footer={true}/>
                <div className="cat-link-container">
                  {renderedVerticals}
                </div>
                {isMobile ? (
                  <div className="footer-subcontent">
                    {FooterSubscribe}
                  </div>
                ) : (
                  <div className="footer-search">
                    <SearchForm cssClass="nav-item" canCollapse={false} parent="footer" />
                  </div>
                )}
                {renderedSocials}
              </div>
            </div>
          </div>
        
      </div>
    );
  }
}

const mapStateToProps = ({ isMobile }) => ({ isMobile });

const FooterContainer = connect(mapStateToProps)(Footer);

export default FooterContainer;
